import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'horaFormatada',
  pure: false 
})
@Injectable({
    providedIn: 'root' // torna o pipe injetável globalmente
  })
export class HoraFormatadaPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(hora: string): string {
    const lang = this.translate.currentLang;
  
    if (lang === 'en-US' && hora && hora.includes(':')) {
      const [hourStr, minutes] = hora.split(':');
      const hour = parseInt(hourStr, 10);
  
      if (isNaN(hour) || isNaN(parseInt(minutes, 10))) {
        return hora; // Se a hora for inválida, retorna como está
      }
  
      const period = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  
      return `${hour12}:${minutes} ${period}`;
    }
  
    // Se não for 'en-US', retorna no formato original (ex: 06:30)
    return hora;
  }
}